/**
 * @flow
 * @relayHash ac400fc54eb576384c73a01baa456d08
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type FavoritesContainer_viewer$ref = any;
export type PortfolioItemsSortByTypes = "CUSTOM" | "NET_PRICE_ASC" | "NET_PRICE_DESC" | "PRICE_ASC" | "PRICE_DESC" | "RECENTLY_CREATED" | "RECENTLY_MODIFIED" | "%future added value";
export type PortfolioTypes = "CART" | "FOLDER" | "HEART" | "PROCUREMENT" | "PROJECT" | "%future added value";
export type PortfoliosSortByTypes = "ALPHABETICAL" | "CREATED" | "CUSTOM" | "MODIFIED" | "%future added value";
export type favoritesRootQueryVariables = {|
  page: number,
  userId: string,
  after?: ?string,
  userIds: $ReadOnlyArray<?string>,
  hasUserId: boolean,
  first: number,
  sortBy?: ?PortfolioItemsSortByTypes,
  foldersSort?: ?PortfoliosSortByTypes,
  searchTerm?: ?string,
  portfolioIds?: ?$ReadOnlyArray<?string>,
  portfolioTypes?: ?$ReadOnlyArray<?PortfolioTypes>,
  projectId: string,
  loadPortfolioData: boolean,
  selectedItemIds: $ReadOnlyArray<?string>,
  useProjectEndpoint: boolean,
  isFolders: boolean,
  isFollowing: boolean,
  isItems: boolean,
  isProjects: boolean,
  isSinglePortfolio: boolean,
  isTrade: boolean,
  itemId?: ?string,
  shouldFetchItem?: ?boolean,
  itemIds?: ?$ReadOnlyArray<?string>,
  shouldFetchConversation?: ?boolean,
  shouldFetchTransaction?: ?boolean,
  showSeller: boolean,
  zipCode?: ?string,
  country?: ?string,
  canCheckZipCode?: ?boolean,
  conversationId?: ?string,
  hasConversationId?: ?boolean,
|};
export type favoritesRootQueryResponse = {|
  +viewer: ?{|
    +$fragmentRefs: FavoritesContainer_viewer$ref
  |}
|};
export type favoritesRootQuery = {|
  variables: favoritesRootQueryVariables,
  response: favoritesRootQueryResponse,
|};
*/


const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "page",
    "type": "Int!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "userId",
    "type": "String!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "after",
    "type": "String",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "userIds",
    "type": "[String]!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "hasUserId",
    "type": "Boolean!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "first",
    "type": "Int!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "sortBy",
    "type": "PortfolioItemsSortByTypes",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "foldersSort",
    "type": "PortfoliosSortByTypes",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "searchTerm",
    "type": "String",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "portfolioIds",
    "type": "[String]",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "portfolioTypes",
    "type": "[PortfolioTypes]",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "projectId",
    "type": "String!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "loadPortfolioData",
    "type": "Boolean!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "selectedItemIds",
    "type": "[String]!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "useProjectEndpoint",
    "type": "Boolean!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "isFolders",
    "type": "Boolean!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "isFollowing",
    "type": "Boolean!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "isItems",
    "type": "Boolean!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "isProjects",
    "type": "Boolean!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "isSinglePortfolio",
    "type": "Boolean!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "isTrade",
    "type": "Boolean!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "itemId",
    "type": "String",
    "defaultValue": ""
  },
  {
    "kind": "LocalArgument",
    "name": "shouldFetchItem",
    "type": "Boolean",
    "defaultValue": false
  },
  {
    "kind": "LocalArgument",
    "name": "itemIds",
    "type": "[String]",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "shouldFetchConversation",
    "type": "Boolean",
    "defaultValue": false
  },
  {
    "kind": "LocalArgument",
    "name": "shouldFetchTransaction",
    "type": "Boolean",
    "defaultValue": false
  },
  {
    "kind": "LocalArgument",
    "name": "showSeller",
    "type": "Boolean!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "zipCode",
    "type": "String",
    "defaultValue": ""
  },
  {
    "kind": "LocalArgument",
    "name": "country",
    "type": "String",
    "defaultValue": ""
  },
  {
    "kind": "LocalArgument",
    "name": "canCheckZipCode",
    "type": "Boolean",
    "defaultValue": false
  },
  {
    "kind": "LocalArgument",
    "name": "conversationId",
    "type": "ID",
    "defaultValue": 0
  },
  {
    "kind": "LocalArgument",
    "name": "hasConversationId",
    "type": "Boolean",
    "defaultValue": false
  }
],
v1 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v2 = {
  "kind": "Variable",
  "name": "userIds",
  "variableName": "userIds",
  "type": "[String]"
},
v3 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 200,
    "type": "Int"
  },
  (v2/*: any*/)
],
v4 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "serviceId",
  "args": null,
  "storageKey": null
},
v5 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "name",
  "args": null,
  "storageKey": null
},
v6 = {
  "kind": "Literal",
  "name": "first",
  "value": 10,
  "type": "Int"
},
v7 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "country",
  "args": null,
  "storageKey": null
},
v8 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "city",
  "args": null,
  "storageKey": null
},
v9 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "formattedAddress",
  "args": null,
  "storageKey": null
},
v10 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "line1",
  "args": null,
  "storageKey": null
},
v11 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "state",
  "args": null,
  "storageKey": null
},
v12 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "zipCode",
  "args": null,
  "storageKey": null
},
v13 = [
  {
    "kind": "Variable",
    "name": "userId",
    "variableName": "userId",
    "type": "String!"
  }
],
v14 = [
  (v4/*: any*/),
  (v1/*: any*/)
],
v15 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "tradeFirm",
  "storageKey": null,
  "args": null,
  "concreteType": "TradeFirmType",
  "plural": false,
  "selections": (v14/*: any*/)
},
v16 = {
  "kind": "ScalarField",
  "alias": "isVisuallySimilarEnabled",
  "name": "isEnabledByLocale",
  "args": [
    {
      "kind": "Literal",
      "name": "featureName",
      "value": "VISUALLY_SIMILAR",
      "type": "String!"
    }
  ],
  "storageKey": "isEnabledByLocale(featureName:\"VISUALLY_SIMILAR\")"
},
v17 = {
  "kind": "Literal",
  "name": "numItems",
  "value": 2,
  "type": "Int!"
},
v18 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "displayName",
  "args": null,
  "storageKey": null
},
v19 = [
  (v18/*: any*/),
  {
    "kind": "ScalarField",
    "alias": null,
    "name": "url",
    "args": null,
    "storageKey": null
  }
],
v20 = {
  "kind": "LinkedField",
  "alias": "trendingAttributes",
  "name": "trending",
  "storageKey": "trending(numItems:2,trendType:\"ATTRIBUTE\")",
  "args": [
    (v17/*: any*/),
    {
      "kind": "Literal",
      "name": "trendType",
      "value": "ATTRIBUTE",
      "type": "TrendingTypes!"
    }
  ],
  "concreteType": "TrendingModules",
  "plural": true,
  "selections": (v19/*: any*/)
},
v21 = {
  "kind": "ScalarField",
  "alias": "onlyTradeRequestsQuote",
  "name": "isEnabled",
  "args": [
    {
      "kind": "Literal",
      "name": "key",
      "value": "useOldPdpShippingModals",
      "type": "String!"
    }
  ],
  "storageKey": "isEnabled(key:\"useOldPdpShippingModals\")"
},
v22 = [
  (v5/*: any*/),
  {
    "kind": "ScalarField",
    "alias": null,
    "name": "abbreviation",
    "args": null,
    "storageKey": null
  }
],
v23 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "geography",
  "storageKey": null,
  "args": null,
  "concreteType": "Geography",
  "plural": false,
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "countries",
      "storageKey": null,
      "args": null,
      "concreteType": "GeographyObject",
      "plural": true,
      "selections": (v22/*: any*/)
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "usStates",
      "storageKey": null,
      "args": null,
      "concreteType": "GeographyObject",
      "plural": true,
      "selections": (v22/*: any*/)
    }
  ]
},
v24 = {
  "kind": "LinkedField",
  "alias": "trendingCategories",
  "name": "trending",
  "storageKey": "trending(categoryLevels:3,numItems:2,trendType:\"CATEGORY\")",
  "args": [
    {
      "kind": "Literal",
      "name": "categoryLevels",
      "value": 3,
      "type": "Int"
    },
    (v17/*: any*/),
    {
      "kind": "Literal",
      "name": "trendType",
      "value": "CATEGORY",
      "type": "TrendingTypes!"
    }
  ],
  "concreteType": "TrendingModules",
  "plural": true,
  "selections": (v19/*: any*/)
},
v25 = {
  "kind": "Variable",
  "name": "buyerId",
  "variableName": "userId",
  "type": "String!"
},
v26 = {
  "kind": "Variable",
  "name": "itemId",
  "variableName": "itemId",
  "type": "String!"
},
v27 = [
  (v1/*: any*/),
  (v4/*: any*/)
],
v28 = {
  "kind": "Condition",
  "passingValue": true,
  "condition": "shouldFetchConversation",
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "buyerItemConversation",
      "storageKey": null,
      "args": [
        (v25/*: any*/),
        (v26/*: any*/)
      ],
      "concreteType": "Conversation",
      "plural": false,
      "selections": (v27/*: any*/)
    }
  ]
},
v29 = {
  "kind": "Literal",
  "name": "portfolioTypes",
  "value": [
    "HEART"
  ],
  "type": "[PortfolioTypes]"
},
v30 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "portfolioItemId",
  "args": null,
  "storageKey": null
},
v31 = {
  "kind": "LinkedField",
  "alias": "heartItemMatches",
  "name": "portfolioItemMatches",
  "storageKey": null,
  "args": [
    {
      "kind": "Variable",
      "name": "itemIds",
      "variableName": "selectedItemIds",
      "type": "[String]"
    },
    (v29/*: any*/),
    (v2/*: any*/)
  ],
  "concreteType": "PortfolioItemV2",
  "plural": true,
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "portfolioId",
      "args": null,
      "storageKey": null
    },
    (v30/*: any*/),
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "item",
      "storageKey": null,
      "args": null,
      "concreteType": "Item",
      "plural": false,
      "selections": (v14/*: any*/)
    },
    (v1/*: any*/)
  ]
},
v32 = {
  "kind": "Literal",
  "name": "first",
  "value": 1,
  "type": "Int"
},
v33 = {
  "kind": "LinkedField",
  "alias": "userPortfolios",
  "name": "portfolios",
  "storageKey": null,
  "args": [
    (v32/*: any*/),
    (v29/*: any*/),
    (v2/*: any*/)
  ],
  "concreteType": "PortfoliosConnection",
  "plural": false,
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "edges",
      "storageKey": null,
      "args": null,
      "concreteType": "PortfoliosEdge",
      "plural": true,
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "node",
          "storageKey": null,
          "args": null,
          "concreteType": "PortfolioV2",
          "plural": false,
          "selections": (v14/*: any*/)
        }
      ]
    }
  ]
},
v34 = {
  "kind": "Variable",
  "name": "portfolioTypes",
  "variableName": "portfolioTypes",
  "type": "[PortfolioTypes]"
},
v35 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "isPublic",
  "args": null,
  "storageKey": null
},
v36 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "totalResults",
  "args": null,
  "storageKey": null
},
v37 = {
  "kind": "LinkedField",
  "alias": "totalPortfolioItems",
  "name": "items",
  "storageKey": "items(first:1)",
  "args": [
    (v32/*: any*/)
  ],
  "concreteType": "PortfolioItemsConnection",
  "plural": false,
  "selections": [
    (v36/*: any*/)
  ]
},
v38 = {
  "kind": "Variable",
  "name": "after",
  "variableName": "after",
  "type": "String"
},
v39 = {
  "kind": "Variable",
  "name": "first",
  "variableName": "first",
  "type": "Int"
},
v40 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "numberOfPages",
  "args": null,
  "storageKey": null
},
v41 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "hasNextPage",
  "args": null,
  "storageKey": null
},
v42 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "endCursor",
  "args": null,
  "storageKey": null
},
v43 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "pageInfo",
  "storageKey": null,
  "args": null,
  "concreteType": "PageInfo",
  "plural": false,
  "selections": [
    (v41/*: any*/),
    (v42/*: any*/)
  ]
},
v44 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "cursor",
  "args": null,
  "storageKey": null
},
v45 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "title",
  "args": null,
  "storageKey": null
},
v46 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "contemporaryTrackingString",
  "args": null,
  "storageKey": null
},
v47 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "categoryPath",
  "args": null,
  "storageKey": null
},
v48 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "amount",
  "args": null,
  "storageKey": null
},
v49 = [
  (v48/*: any*/)
],
v50 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "retailPrice",
  "storageKey": null,
  "args": null,
  "concreteType": "FinancialAmount",
  "plural": false,
  "selections": (v49/*: any*/)
},
v51 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "currency",
  "args": null,
  "storageKey": null
},
v52 = [
  (v51/*: any*/)
],
v53 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "convertedAmountList",
  "storageKey": null,
  "args": null,
  "concreteType": "ConvertedAmountList",
  "plural": true,
  "selections": [
    (v48/*: any*/),
    (v51/*: any*/)
  ]
},
v54 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "type",
  "args": null,
  "storageKey": null
},
v55 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "status",
  "args": null,
  "storageKey": null
},
v56 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "key",
  "args": null,
  "storageKey": null
},
v57 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "isSold",
  "args": null,
  "storageKey": null
},
v58 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "handlingTimeDisplay",
  "args": null,
  "storageKey": null
},
v59 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "regionName",
  "args": null,
  "storageKey": null
},
v60 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "convertedAmountList",
  "storageKey": null,
  "args": null,
  "concreteType": "ConvertedAmountList",
  "plural": true,
  "selections": [
    (v51/*: any*/),
    (v48/*: any*/)
  ]
},
v61 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "versions",
  "storageKey": null,
  "args": null,
  "concreteType": "ItemPhotoVersion",
  "plural": true,
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "webPath",
      "args": null,
      "storageKey": null
    }
  ]
},
v62 = {
  "kind": "Variable",
  "name": "buyerId",
  "variableName": "userId",
  "type": "String"
},
v63 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "items",
  "storageKey": null,
  "args": [
    (v38/*: any*/),
    (v39/*: any*/),
    {
      "kind": "Variable",
      "name": "page",
      "variableName": "page",
      "type": "Int"
    },
    {
      "kind": "Variable",
      "name": "searchTerm",
      "variableName": "searchTerm",
      "type": "String"
    },
    {
      "kind": "Variable",
      "name": "sortBy",
      "variableName": "sortBy",
      "type": "PortfolioItemsSortByTypes"
    }
  ],
  "concreteType": "PortfolioItemsConnection",
  "plural": false,
  "selections": [
    (v36/*: any*/),
    (v40/*: any*/),
    (v43/*: any*/),
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "edges",
      "storageKey": null,
      "args": null,
      "concreteType": "PortfolioItemsEdge",
      "plural": true,
      "selections": [
        (v44/*: any*/),
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "node",
          "storageKey": null,
          "args": null,
          "concreteType": "PortfolioItemV2",
          "plural": false,
          "selections": [
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "item",
              "storageKey": null,
              "args": null,
              "concreteType": "Item",
              "plural": false,
              "selections": [
                {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "creators",
                  "storageKey": null,
                  "args": null,
                  "concreteType": "ItemCreator",
                  "plural": true,
                  "selections": [
                    {
                      "kind": "LinkedField",
                      "alias": null,
                      "name": "creator",
                      "storageKey": null,
                      "args": null,
                      "concreteType": "Creator",
                      "plural": false,
                      "selections": [
                        (v18/*: any*/),
                        (v1/*: any*/)
                      ]
                    },
                    (v1/*: any*/),
                    {
                      "kind": "ScalarField",
                      "alias": null,
                      "name": "attribution",
                      "args": null,
                      "storageKey": null
                    }
                  ]
                },
                (v4/*: any*/),
                {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "seller",
                  "storageKey": null,
                  "args": null,
                  "concreteType": "Seller",
                  "plural": false,
                  "selections": [
                    (v4/*: any*/),
                    (v1/*: any*/),
                    {
                      "kind": "LinkedField",
                      "alias": null,
                      "name": "sellerProfile",
                      "storageKey": null,
                      "args": null,
                      "concreteType": "SellerProfile",
                      "plural": false,
                      "selections": [
                        {
                          "kind": "ScalarField",
                          "alias": null,
                          "name": "company",
                          "args": null,
                          "storageKey": null
                        }
                      ]
                    }
                  ]
                },
                (v1/*: any*/),
                (v45/*: any*/),
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "firstPhotoWebPath",
                  "args": [
                    {
                      "kind": "Literal",
                      "name": "size",
                      "value": "large",
                      "type": "ImageVersionTypeName!"
                    }
                  ],
                  "storageKey": "firstPhotoWebPath(size:\"large\")"
                },
                (v46/*: any*/),
                (v47/*: any*/),
                {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "pricing",
                  "storageKey": null,
                  "args": null,
                  "concreteType": "ItemPricing",
                  "plural": false,
                  "selections": [
                    (v50/*: any*/),
                    {
                      "kind": "LinkedField",
                      "alias": null,
                      "name": "totalAmount",
                      "storageKey": null,
                      "args": null,
                      "concreteType": "FinancialAmount",
                      "plural": false,
                      "selections": (v52/*: any*/)
                    },
                    {
                      "kind": "LinkedField",
                      "alias": null,
                      "name": "prices",
                      "storageKey": null,
                      "args": null,
                      "concreteType": "Price",
                      "plural": true,
                      "selections": [
                        {
                          "kind": "LinkedField",
                          "alias": null,
                          "name": "amount",
                          "storageKey": null,
                          "args": null,
                          "concreteType": "FinancialAmount",
                          "plural": false,
                          "selections": [
                            (v48/*: any*/),
                            (v53/*: any*/)
                          ]
                        },
                        {
                          "kind": "ScalarField",
                          "alias": null,
                          "name": "pricePerPiece",
                          "args": null,
                          "storageKey": null
                        },
                        {
                          "kind": "ScalarField",
                          "alias": null,
                          "name": "hidePrice",
                          "args": null,
                          "storageKey": null
                        },
                        {
                          "kind": "ScalarField",
                          "alias": null,
                          "name": "negotiable",
                          "args": null,
                          "storageKey": null
                        },
                        (v54/*: any*/),
                        (v55/*: any*/)
                      ]
                    }
                  ]
                },
                {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "quickViewDisplay",
                  "storageKey": null,
                  "args": null,
                  "concreteType": "QuickViewDisplayType",
                  "plural": false,
                  "selections": [
                    (v45/*: any*/),
                    {
                      "kind": "ScalarField",
                      "alias": "mobileTitle",
                      "name": "title",
                      "args": [
                        {
                          "kind": "Literal",
                          "name": "formatType",
                          "value": "MOBILE",
                          "type": "formatTitleTypes"
                        }
                      ],
                      "storageKey": "title(formatType:\"MOBILE\")"
                    },
                    {
                      "kind": "LinkedField",
                      "alias": null,
                      "name": "paragraphs",
                      "storageKey": null,
                      "args": null,
                      "concreteType": "QuickViewParagraph",
                      "plural": true,
                      "selections": [
                        (v56/*: any*/),
                        {
                          "kind": "ScalarField",
                          "alias": null,
                          "name": "text",
                          "args": null,
                          "storageKey": null
                        },
                        {
                          "kind": "ScalarField",
                          "alias": "mobileText",
                          "name": "text",
                          "args": [
                            {
                              "kind": "Literal",
                              "name": "formatType",
                              "value": "MOBILE",
                              "type": "formatTextTypes"
                            }
                          ],
                          "storageKey": "text(formatType:\"MOBILE\")"
                        }
                      ]
                    }
                  ]
                },
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "localizedPdpUrl",
                  "args": null,
                  "storageKey": null
                },
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "isArt",
                  "args": null,
                  "storageKey": null
                },
                {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "classification",
                  "storageKey": null,
                  "args": null,
                  "concreteType": "ItemClassification",
                  "plural": false,
                  "selections": [
                    {
                      "kind": "ScalarField",
                      "alias": null,
                      "name": "creationDate",
                      "args": null,
                      "storageKey": null
                    }
                  ]
                },
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "vertical",
                  "args": null,
                  "storageKey": null
                },
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "canMultipleQuantityBePurchased",
                  "args": null,
                  "storageKey": null
                },
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "isOnHold",
                  "args": null,
                  "storageKey": null
                },
                (v57/*: any*/),
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "hasRequestedHoldForBuyer",
                  "args": [
                    (v25/*: any*/)
                  ],
                  "storageKey": null
                },
                {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "activeHold",
                  "storageKey": null,
                  "args": null,
                  "concreteType": "Hold",
                  "plural": false,
                  "selections": [
                    {
                      "kind": "ScalarField",
                      "alias": null,
                      "name": "expirationDate",
                      "args": null,
                      "storageKey": null
                    },
                    (v1/*: any*/)
                  ]
                },
                {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "shipmentQuotes",
                  "storageKey": null,
                  "args": null,
                  "concreteType": "ShipmentQuote",
                  "plural": true,
                  "selections": [
                    {
                      "kind": "ScalarField",
                      "alias": null,
                      "name": "isLocalPickup",
                      "args": null,
                      "storageKey": null
                    },
                    {
                      "kind": "ScalarField",
                      "alias": null,
                      "name": "isComplimentary",
                      "args": null,
                      "storageKey": null
                    },
                    (v58/*: any*/),
                    {
                      "kind": "LinkedField",
                      "alias": null,
                      "name": "serviceMethod",
                      "storageKey": null,
                      "args": null,
                      "concreteType": "ShipmentServiceMethod",
                      "plural": false,
                      "selections": [
                        (v18/*: any*/),
                        {
                          "kind": "LinkedField",
                          "alias": null,
                          "name": "region",
                          "storageKey": null,
                          "args": null,
                          "concreteType": "Region",
                          "plural": false,
                          "selections": [
                            (v59/*: any*/),
                            (v1/*: any*/)
                          ]
                        },
                        (v1/*: any*/)
                      ]
                    },
                    {
                      "kind": "LinkedField",
                      "alias": null,
                      "name": "totalAmount",
                      "storageKey": null,
                      "args": null,
                      "concreteType": "FinancialAmount",
                      "plural": false,
                      "selections": [
                        (v60/*: any*/),
                        (v48/*: any*/)
                      ]
                    },
                    (v1/*: any*/)
                  ]
                },
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "isCustomizable",
                  "args": null,
                  "storageKey": null
                },
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "isMultiSku",
                  "args": null,
                  "storageKey": null
                },
                {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "displayPrice",
                  "storageKey": null,
                  "args": [
                    {
                      "kind": "Variable",
                      "name": "isTrade",
                      "variableName": "isTrade",
                      "type": "Boolean"
                    },
                    {
                      "kind": "Literal",
                      "name": "page",
                      "value": "searchAndBrowse",
                      "type": "PageDisplayEnum"
                    }
                  ],
                  "concreteType": "ItemDisplayPriceType",
                  "plural": true,
                  "selections": [
                    (v53/*: any*/),
                    {
                      "kind": "ScalarField",
                      "alias": null,
                      "name": "quantityDisplay",
                      "args": null,
                      "storageKey": null
                    },
                    {
                      "kind": "ScalarField",
                      "alias": null,
                      "name": "percentageOff",
                      "args": null,
                      "storageKey": null
                    },
                    (v54/*: any*/),
                    {
                      "kind": "ScalarField",
                      "alias": null,
                      "name": "showPriceLabel",
                      "args": null,
                      "storageKey": null
                    }
                  ]
                },
                {
                  "kind": "LinkedField",
                  "alias": "productPhotos",
                  "name": "photos",
                  "storageKey": "photos(limit:1)",
                  "args": [
                    {
                      "kind": "Literal",
                      "name": "limit",
                      "value": 1,
                      "type": "Int"
                    }
                  ],
                  "concreteType": "ItemPhoto",
                  "plural": true,
                  "selections": [
                    {
                      "kind": "ScalarField",
                      "alias": null,
                      "name": "placeholder",
                      "args": null,
                      "storageKey": null
                    },
                    {
                      "kind": "ScalarField",
                      "alias": null,
                      "name": "smallPath",
                      "args": null,
                      "storageKey": null
                    },
                    (v61/*: any*/),
                    (v1/*: any*/)
                  ]
                },
                {
                  "kind": "Condition",
                  "passingValue": true,
                  "condition": "hasUserId",
                  "selections": [
                    {
                      "kind": "LinkedField",
                      "alias": "tilesProjects",
                      "name": "projects",
                      "storageKey": null,
                      "args": (v13/*: any*/),
                      "concreteType": "Project",
                      "plural": true,
                      "selections": [
                        (v5/*: any*/),
                        (v4/*: any*/),
                        (v1/*: any*/)
                      ]
                    },
                    {
                      "kind": "LinkedField",
                      "alias": "pdpDisplayInfo",
                      "name": "displayInfo",
                      "storageKey": null,
                      "args": [
                        (v62/*: any*/),
                        {
                          "kind": "Literal",
                          "name": "page",
                          "value": "pdp",
                          "type": "PageDisplayEnum"
                        }
                      ],
                      "concreteType": "ItemDisplayInfo",
                      "plural": false,
                      "selections": [
                        {
                          "kind": "LinkedField",
                          "alias": null,
                          "name": "pricing",
                          "storageKey": null,
                          "args": null,
                          "concreteType": "PriceInfoDisplay",
                          "plural": false,
                          "selections": [
                            {
                              "kind": "ScalarField",
                              "alias": null,
                              "name": "showRetail",
                              "args": null,
                              "storageKey": null
                            },
                            {
                              "kind": "ScalarField",
                              "alias": null,
                              "name": "showNet",
                              "args": null,
                              "storageKey": null
                            },
                            {
                              "kind": "ScalarField",
                              "alias": null,
                              "name": "showSale",
                              "args": null,
                              "storageKey": null
                            },
                            {
                              "kind": "ScalarField",
                              "alias": null,
                              "name": "showPUR",
                              "args": null,
                              "storageKey": null
                            },
                            {
                              "kind": "ScalarField",
                              "alias": null,
                              "name": "showSold",
                              "args": null,
                              "storageKey": null
                            },
                            {
                              "kind": "ScalarField",
                              "alias": null,
                              "name": "showOnHold",
                              "args": null,
                              "storageKey": null
                            }
                          ]
                        }
                      ]
                    }
                  ]
                }
              ]
            },
            (v1/*: any*/),
            (v30/*: any*/),
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "note",
              "args": null,
              "storageKey": null
            }
          ]
        }
      ]
    }
  ]
},
v64 = {
  "kind": "Condition",
  "passingValue": true,
  "condition": "canCheckZipCode",
  "selections": [
    {
      "kind": "LinkedField",
      "alias": "zipCodeLookUp",
      "name": "zipCode",
      "storageKey": null,
      "args": [
        {
          "kind": "Variable",
          "name": "country",
          "variableName": "country",
          "type": "String!"
        },
        {
          "kind": "Variable",
          "name": "zipCode",
          "variableName": "zipCode",
          "type": "String!"
        }
      ],
      "concreteType": "Address",
      "plural": true,
      "selections": [
        (v8/*: any*/),
        (v11/*: any*/),
        (v1/*: any*/)
      ]
    }
  ]
},
v65 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "isVerifiedTrade",
  "args": null,
  "storageKey": null
},
v66 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "firstName",
  "args": null,
  "storageKey": null
},
v67 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "lastName",
  "args": null,
  "storageKey": null
},
v68 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "firstValidShippingAddress",
  "storageKey": null,
  "args": null,
  "concreteType": "Address",
  "plural": false,
  "selections": (v14/*: any*/)
},
v69 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "addressBook",
  "storageKey": null,
  "args": null,
  "concreteType": "AddressBook",
  "plural": false,
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "addressList",
      "storageKey": null,
      "args": null,
      "concreteType": "Address",
      "plural": true,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "line2",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "sourceId",
          "args": null,
          "storageKey": null
        },
        (v18/*: any*/),
        (v9/*: any*/),
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "displayCountry",
          "args": null,
          "storageKey": null
        },
        (v66/*: any*/),
        (v67/*: any*/),
        (v10/*: any*/),
        (v4/*: any*/),
        (v7/*: any*/),
        (v8/*: any*/),
        (v11/*: any*/),
        (v12/*: any*/),
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "phoneNumber",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "validation",
          "storageKey": null,
          "args": null,
          "concreteType": "AddressValidation",
          "plural": false,
          "selections": [
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "buyerShipping",
              "storageKey": null,
              "args": null,
              "concreteType": "ValidationResult",
              "plural": false,
              "selections": [
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "valid",
                  "args": null,
                  "storageKey": null
                }
              ]
            }
          ]
        },
        (v1/*: any*/)
      ]
    }
  ]
},
v70 = [
  (v62/*: any*/),
  (v26/*: any*/)
],
v71 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "isCustom",
  "args": null,
  "storageKey": null
},
v72 = {
  "kind": "Condition",
  "passingValue": true,
  "condition": "hasUserId",
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "user",
      "storageKey": null,
      "args": (v13/*: any*/),
      "concreteType": "User",
      "plural": false,
      "selections": [
        (v1/*: any*/),
        (v65/*: any*/),
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "profile",
          "storageKey": null,
          "args": null,
          "concreteType": "Profile",
          "plural": false,
          "selections": [
            (v66/*: any*/),
            (v67/*: any*/),
            (v51/*: any*/),
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "email",
              "args": null,
              "storageKey": null
            }
          ]
        },
        (v4/*: any*/),
        (v68/*: any*/),
        (v69/*: any*/),
        (v15/*: any*/)
      ]
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "relevantShippingInfo",
      "storageKey": null,
      "args": (v70/*: any*/),
      "concreteType": "QueryRelevantShippingInfo",
      "plural": false,
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "shipmentQuote",
          "storageKey": null,
          "args": null,
          "concreteType": "ShipmentQuote",
          "plural": false,
          "selections": [
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "subTotalAmount",
              "storageKey": null,
              "args": null,
              "concreteType": "FinancialAmount",
              "plural": false,
              "selections": (v49/*: any*/)
            },
            (v71/*: any*/),
            (v1/*: any*/)
          ]
        }
      ]
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "projects",
      "storageKey": null,
      "args": (v3/*: any*/),
      "concreteType": "ProjectConnection",
      "plural": false,
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "edges",
          "storageKey": null,
          "args": null,
          "concreteType": "ProjectEdge",
          "plural": true,
          "selections": [
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "node",
              "storageKey": null,
              "args": null,
              "concreteType": "Project",
              "plural": false,
              "selections": [
                (v4/*: any*/),
                (v5/*: any*/),
                {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "portfolio",
                  "storageKey": null,
                  "args": null,
                  "concreteType": "PortfolioV2",
                  "plural": false,
                  "selections": (v14/*: any*/)
                },
                (v1/*: any*/)
              ]
            }
          ]
        }
      ]
    }
  ]
},
v73 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "totalAmount",
  "storageKey": null,
  "args": null,
  "concreteType": "FinancialAmount",
  "plural": false,
  "selections": [
    (v51/*: any*/),
    (v48/*: any*/),
    (v60/*: any*/)
  ]
},
v74 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "is1stdibsBilledQuote",
  "args": null,
  "storageKey": null
},
v75 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "is1stdibsWhiteGloveQuote",
  "args": null,
  "storageKey": null
},
v76 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "buyerServiceMethodDisplay",
  "args": null,
  "storageKey": null
},
v77 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "handlingTime",
  "storageKey": null,
  "args": null,
  "concreteType": "Period",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "numberOfUnits",
      "args": null,
      "storageKey": null
    }
  ]
},
v78 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "serviceMethod",
  "storageKey": null,
  "args": null,
  "concreteType": "ShipmentServiceMethod",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "serviceType",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "serviceMethodType",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "region",
      "storageKey": null,
      "args": null,
      "concreteType": "Region",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "code",
          "args": null,
          "storageKey": null
        },
        (v59/*: any*/),
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "regionType",
          "args": null,
          "storageKey": null
        },
        (v1/*: any*/),
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "regionBoundary",
          "storageKey": null,
          "args": null,
          "concreteType": "RegionBoundary",
          "plural": false,
          "selections": [
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "type",
              "storageKey": null,
              "args": null,
              "concreteType": "RegionBoundaryType",
              "plural": false,
              "selections": [
                (v5/*: any*/)
              ]
            }
          ]
        }
      ]
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "windowMin",
      "storageKey": null,
      "args": null,
      "concreteType": "Period",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": "numberOfDays",
          "name": "numberOfUnits",
          "args": null,
          "storageKey": null
        }
      ]
    },
    (v1/*: any*/)
  ]
},
v79 = {
  "kind": "Condition",
  "passingValue": true,
  "condition": "shouldFetchItem",
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "item",
      "storageKey": null,
      "args": [
        (v26/*: any*/)
      ],
      "concreteType": "Item",
      "plural": false,
      "selections": [
        (v45/*: any*/),
        (v57/*: any*/),
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "seller",
          "storageKey": null,
          "args": null,
          "concreteType": "Seller",
          "plural": false,
          "selections": [
            (v4/*: any*/),
            (v1/*: any*/),
            {
              "kind": "Condition",
              "passingValue": true,
              "condition": "hasUserId",
              "selections": [
                {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "favoritesByUser",
                  "storageKey": null,
                  "args": [
                    {
                      "kind": "Variable",
                      "name": "userIds",
                      "variableName": "userId",
                      "type": "String!"
                    }
                  ],
                  "concreteType": "Favorite",
                  "plural": true,
                  "selections": (v14/*: any*/)
                }
              ]
            }
          ]
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "hasPreQuotedShipping",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": "itemIsOnHold",
          "name": "isOnHold",
          "args": [
            (v62/*: any*/)
          ],
          "storageKey": null
        },
        (v1/*: any*/),
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "address",
          "storageKey": null,
          "args": null,
          "concreteType": "Address",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "alias": "itemAddress",
              "name": "displayCityStateCountry",
              "args": [
                {
                  "kind": "Literal",
                  "name": "fullCountryName",
                  "value": true,
                  "type": "Boolean"
                }
              ],
              "storageKey": "displayCityStateCountry(fullCountryName:true)"
            },
            (v1/*: any*/)
          ]
        }
      ]
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "relevantShippingInfo",
      "storageKey": null,
      "args": (v70/*: any*/),
      "concreteType": "QueryRelevantShippingInfo",
      "plural": false,
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "shipment",
          "storageKey": null,
          "args": null,
          "concreteType": "Shipment",
          "plural": false,
          "selections": [
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "shippingAddress",
              "storageKey": null,
              "args": null,
              "concreteType": "Address",
              "plural": false,
              "selections": [
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "displayCityStateCountry",
                  "args": null,
                  "storageKey": null
                },
                (v1/*: any*/)
              ]
            },
            (v1/*: any*/)
          ]
        },
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "shipmentQuote",
          "storageKey": null,
          "args": null,
          "concreteType": "ShipmentQuote",
          "plural": false,
          "selections": [
            (v73/*: any*/),
            (v71/*: any*/),
            (v74/*: any*/),
            (v75/*: any*/),
            (v58/*: any*/),
            (v4/*: any*/),
            (v76/*: any*/),
            (v77/*: any*/),
            (v78/*: any*/),
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "buyerSubTotalAmount",
              "storageKey": null,
              "args": null,
              "concreteType": "FinancialAmount",
              "plural": false,
              "selections": [
                (v60/*: any*/)
              ]
            },
            (v1/*: any*/)
          ]
        }
      ]
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "shipmentQuotes",
      "storageKey": null,
      "args": [
        (v6/*: any*/),
        {
          "kind": "Variable",
          "name": "itemId",
          "variableName": "itemId",
          "type": "String"
        },
        {
          "kind": "Literal",
          "name": "searchView",
          "value": "IGNORE_LOCAL_PICKUP",
          "type": "SearchView"
        }
      ],
      "concreteType": "ShipmentQuotesConnection",
      "plural": false,
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "edges",
          "storageKey": null,
          "args": null,
          "concreteType": "ShipmentQuotesEdge",
          "plural": true,
          "selections": [
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "node",
              "storageKey": null,
              "args": null,
              "concreteType": "ShipmentQuote",
              "plural": false,
              "selections": [
                (v4/*: any*/),
                (v74/*: any*/),
                (v75/*: any*/),
                (v58/*: any*/),
                (v73/*: any*/),
                (v76/*: any*/),
                (v77/*: any*/),
                (v78/*: any*/),
                {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "buyerSubTotalAmount",
                  "storageKey": null,
                  "args": null,
                  "concreteType": "FinancialAmount",
                  "plural": false,
                  "selections": [
                    (v48/*: any*/),
                    (v60/*: any*/)
                  ]
                },
                (v1/*: any*/)
              ]
            }
          ]
        }
      ]
    }
  ]
},
v80 = {
  "kind": "Condition",
  "passingValue": true,
  "condition": "hasConversationId",
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "conversation",
      "storageKey": null,
      "args": [
        {
          "kind": "Variable",
          "name": "conversationId",
          "variableName": "conversationId",
          "type": "ID!"
        }
      ],
      "concreteType": "Conversation",
      "plural": false,
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "transaction",
          "storageKey": null,
          "args": null,
          "concreteType": "Transaction",
          "plural": false,
          "selections": (v27/*: any*/)
        },
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "originalBuyer",
          "storageKey": null,
          "args": null,
          "concreteType": "ConversationMember",
          "plural": false,
          "selections": [
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "user",
              "storageKey": null,
              "args": null,
              "concreteType": "User",
              "plural": false,
              "selections": [
                {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "profile",
                  "storageKey": null,
                  "args": null,
                  "concreteType": "Profile",
                  "plural": false,
                  "selections": [
                    (v66/*: any*/),
                    (v67/*: any*/)
                  ]
                },
                (v65/*: any*/),
                (v4/*: any*/),
                (v68/*: any*/),
                (v69/*: any*/),
                (v15/*: any*/),
                (v1/*: any*/)
              ]
            },
            (v1/*: any*/)
          ]
        },
        (v1/*: any*/)
      ]
    }
  ]
},
v81 = {
  "kind": "Condition",
  "passingValue": true,
  "condition": "shouldFetchTransaction",
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "transactions",
      "storageKey": null,
      "args": [
        {
          "kind": "Variable",
          "name": "buyerId",
          "variableName": "userIds",
          "type": "[String]"
        },
        (v32/*: any*/),
        {
          "kind": "Variable",
          "name": "itemId",
          "variableName": "itemIds",
          "type": "[String]"
        },
        {
          "kind": "Literal",
          "name": "sort",
          "value": "createdDate desc",
          "type": "String"
        },
        {
          "kind": "Literal",
          "name": "viewName",
          "value": "mc.conversationTransaction",
          "type": "String"
        }
      ],
      "concreteType": "TransactionConnection",
      "plural": false,
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "edges",
          "storageKey": null,
          "args": null,
          "concreteType": "TransactionEdge",
          "plural": true,
          "selections": [
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "node",
              "storageKey": null,
              "args": null,
              "concreteType": "Transaction",
              "plural": false,
              "selections": [
                (v1/*: any*/),
                (v4/*: any*/),
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "isCanceled",
                  "args": null,
                  "storageKey": null
                },
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "hasCompletedCheckout",
                  "args": null,
                  "storageKey": null
                },
                {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "lastShipmentQuote",
                  "storageKey": null,
                  "args": null,
                  "concreteType": "ShipmentQuote",
                  "plural": false,
                  "selections": [
                    (v55/*: any*/),
                    (v1/*: any*/)
                  ]
                }
              ]
            }
          ]
        }
      ]
    }
  ]
},
v82 = {
  "kind": "Literal",
  "name": "first",
  "value": 12,
  "type": "Int"
},
v83 = [
  (v38/*: any*/),
  (v82/*: any*/),
  {
    "kind": "Literal",
    "name": "types",
    "value": [
      "SEARCH",
      "SELLER",
      "DESIGNER"
    ],
    "type": "[types]"
  }
],
v84 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "photos",
  "storageKey": null,
  "args": null,
  "concreteType": "ItemPhoto",
  "plural": true,
  "selections": [
    (v61/*: any*/),
    (v1/*: any*/)
  ]
},
v85 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "__typename",
  "args": null,
  "storageKey": null
},
v86 = {
  "kind": "Condition",
  "passingValue": true,
  "condition": "loadPortfolioData",
  "selections": [
    (v31/*: any*/),
    (v33/*: any*/)
  ]
},
v87 = [
  (v38/*: any*/),
  (v39/*: any*/),
  (v34/*: any*/),
  {
    "kind": "Variable",
    "name": "sortBy",
    "variableName": "foldersSort",
    "type": "PortfoliosSortByTypes"
  },
  (v2/*: any*/)
],
v88 = [
  (v1/*: any*/),
  (v4/*: any*/),
  (v5/*: any*/),
  {
    "kind": "ScalarField",
    "alias": null,
    "name": "description",
    "args": null,
    "storageKey": null
  },
  (v35/*: any*/),
  {
    "kind": "ScalarField",
    "alias": null,
    "name": "ownerId",
    "args": null,
    "storageKey": null
  },
  (v37/*: any*/),
  (v63/*: any*/)
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "favoritesRootQuery",
    "type": "RootQueryType",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [
          {
            "kind": "FragmentSpread",
            "name": "FavoritesContainer_viewer",
            "args": null
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "favoritesRootQuery",
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "kind": "Condition",
            "passingValue": true,
            "condition": "isProjects",
            "selections": [
              {
                "kind": "Condition",
                "passingValue": true,
                "condition": "hasUserId",
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "projects",
                    "storageKey": null,
                    "args": (v3/*: any*/),
                    "concreteType": "ProjectConnection",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "edges",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "ProjectEdge",
                        "plural": true,
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "node",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "Project",
                            "plural": false,
                            "selections": [
                              (v4/*: any*/),
                              {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "createdDate",
                                "args": null,
                                "storageKey": null
                              },
                              (v5/*: any*/),
                              {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "installDate",
                                "args": null,
                                "storageKey": null
                              },
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "portfolio",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "PortfolioV2",
                                "plural": false,
                                "selections": [
                                  (v4/*: any*/),
                                  {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "items",
                                    "storageKey": "items(first:10)",
                                    "args": [
                                      (v6/*: any*/)
                                    ],
                                    "concreteType": "PortfolioItemsConnection",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "kind": "LinkedField",
                                        "alias": null,
                                        "name": "edges",
                                        "storageKey": null,
                                        "args": null,
                                        "concreteType": "PortfolioItemsEdge",
                                        "plural": true,
                                        "selections": [
                                          {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "node",
                                            "storageKey": null,
                                            "args": null,
                                            "concreteType": "PortfolioItemV2",
                                            "plural": false,
                                            "selections": [
                                              (v1/*: any*/)
                                            ]
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  (v1/*: any*/)
                                ]
                              },
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "shippingAddress",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "Address",
                                "plural": false,
                                "selections": [
                                  (v7/*: any*/),
                                  (v8/*: any*/),
                                  (v9/*: any*/),
                                  (v10/*: any*/),
                                  (v11/*: any*/),
                                  (v12/*: any*/),
                                  (v1/*: any*/)
                                ]
                              },
                              (v1/*: any*/)
                            ]
                          }
                        ]
                      }
                    ]
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "user",
                    "storageKey": null,
                    "args": (v13/*: any*/),
                    "concreteType": "User",
                    "plural": false,
                    "selections": [
                      (v15/*: any*/),
                      (v1/*: any*/)
                    ]
                  }
                ]
              }
            ]
          },
          {
            "kind": "Condition",
            "passingValue": true,
            "condition": "isItems",
            "selections": [
              (v16/*: any*/),
              (v20/*: any*/),
              (v21/*: any*/),
              (v23/*: any*/),
              (v24/*: any*/),
              (v28/*: any*/),
              {
                "kind": "Condition",
                "passingValue": true,
                "condition": "loadPortfolioData",
                "selections": [
                  (v31/*: any*/),
                  (v33/*: any*/),
                  {
                    "kind": "LinkedField",
                    "alias": "itemsPortfolios",
                    "name": "portfolios",
                    "storageKey": null,
                    "args": [
                      (v32/*: any*/),
                      (v34/*: any*/),
                      (v2/*: any*/)
                    ],
                    "concreteType": "PortfoliosConnection",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "edges",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "PortfoliosEdge",
                        "plural": true,
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "node",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "PortfolioV2",
                            "plural": false,
                            "selections": [
                              (v1/*: any*/),
                              (v35/*: any*/),
                              (v4/*: any*/),
                              (v37/*: any*/),
                              (v63/*: any*/)
                            ]
                          }
                        ]
                      }
                    ]
                  }
                ]
              },
              (v64/*: any*/),
              (v72/*: any*/),
              (v79/*: any*/),
              (v80/*: any*/),
              (v81/*: any*/)
            ]
          },
          {
            "kind": "Condition",
            "passingValue": true,
            "condition": "isFollowing",
            "selections": [
              (v24/*: any*/),
              (v20/*: any*/),
              {
                "kind": "Condition",
                "passingValue": true,
                "condition": "hasUserId",
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "user",
                    "storageKey": null,
                    "args": (v13/*: any*/),
                    "concreteType": "User",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "favorites",
                        "storageKey": null,
                        "args": (v83/*: any*/),
                        "concreteType": "favoritesConnection",
                        "plural": false,
                        "selections": [
                          (v36/*: any*/),
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "edges",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "favoritesEdge",
                            "plural": true,
                            "selections": [
                              (v44/*: any*/),
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "node",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "Favorite",
                                "plural": false,
                                "selections": [
                                  (v4/*: any*/),
                                  {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "page",
                                    "args": null,
                                    "storageKey": null
                                  },
                                  (v5/*: any*/),
                                  {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "query",
                                    "args": null,
                                    "storageKey": null
                                  },
                                  (v54/*: any*/),
                                  {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "parameters",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "Parameters",
                                    "plural": true,
                                    "selections": [
                                      (v56/*: any*/),
                                      (v54/*: any*/),
                                      {
                                        "kind": "ScalarField",
                                        "alias": null,
                                        "name": "values",
                                        "args": null,
                                        "storageKey": null
                                      },
                                      (v1/*: any*/)
                                    ]
                                  },
                                  {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "items",
                                    "storageKey": "items(first:12,page:0)",
                                    "args": [
                                      (v82/*: any*/),
                                      {
                                        "kind": "Literal",
                                        "name": "page",
                                        "value": 0,
                                        "type": "Int"
                                      }
                                    ],
                                    "concreteType": "FavoriteItemsConnection",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "kind": "LinkedField",
                                        "alias": null,
                                        "name": "edges",
                                        "storageKey": null,
                                        "args": null,
                                        "concreteType": "FavoriteItemsEdge",
                                        "plural": true,
                                        "selections": [
                                          {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "node",
                                            "storageKey": null,
                                            "args": null,
                                            "concreteType": "Item",
                                            "plural": false,
                                            "selections": [
                                              (v4/*: any*/),
                                              (v45/*: any*/),
                                              {
                                                "kind": "ScalarField",
                                                "alias": null,
                                                "name": "pdpURL",
                                                "args": null,
                                                "storageKey": null
                                              },
                                              (v46/*: any*/),
                                              (v47/*: any*/),
                                              {
                                                "kind": "LinkedField",
                                                "alias": null,
                                                "name": "seller",
                                                "storageKey": null,
                                                "args": null,
                                                "concreteType": "Seller",
                                                "plural": false,
                                                "selections": (v14/*: any*/)
                                              },
                                              {
                                                "kind": "LinkedField",
                                                "alias": null,
                                                "name": "pricing",
                                                "storageKey": null,
                                                "args": null,
                                                "concreteType": "ItemPricing",
                                                "plural": false,
                                                "selections": [
                                                  (v50/*: any*/)
                                                ]
                                              },
                                              (v84/*: any*/),
                                              (v1/*: any*/)
                                            ]
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  (v1/*: any*/),
                                  (v85/*: any*/)
                                ]
                              }
                            ]
                          },
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "pageInfo",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "PageInfo",
                            "plural": false,
                            "selections": [
                              (v42/*: any*/),
                              (v41/*: any*/)
                            ]
                          }
                        ]
                      },
                      {
                        "kind": "LinkedHandle",
                        "alias": null,
                        "name": "favorites",
                        "args": (v83/*: any*/),
                        "handle": "connection",
                        "key": "FollowingRefetchWrapper_favorites",
                        "filters": [
                          "types"
                        ]
                      },
                      (v1/*: any*/)
                    ]
                  }
                ]
              },
              (v86/*: any*/)
            ]
          },
          {
            "kind": "Condition",
            "passingValue": true,
            "condition": "isFolders",
            "selections": [
              (v24/*: any*/),
              (v20/*: any*/),
              {
                "kind": "Condition",
                "passingValue": true,
                "condition": "hasUserId",
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "user",
                    "storageKey": null,
                    "args": (v13/*: any*/),
                    "concreteType": "User",
                    "plural": false,
                    "selections": [
                      (v4/*: any*/),
                      (v65/*: any*/),
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "profile",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "Profile",
                        "plural": false,
                        "selections": (v52/*: any*/)
                      },
                      (v1/*: any*/)
                    ]
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "portfolios",
                    "storageKey": null,
                    "args": (v87/*: any*/),
                    "concreteType": "PortfoliosConnection",
                    "plural": false,
                    "selections": [
                      (v36/*: any*/),
                      (v43/*: any*/),
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "edges",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "PortfoliosEdge",
                        "plural": true,
                        "selections": [
                          (v44/*: any*/),
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "node",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "PortfolioV2",
                            "plural": false,
                            "selections": [
                              (v1/*: any*/),
                              (v4/*: any*/),
                              (v5/*: any*/),
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "items",
                                "storageKey": "items(first:4,sortBy:\"CUSTOM\")",
                                "args": [
                                  {
                                    "kind": "Literal",
                                    "name": "first",
                                    "value": 4,
                                    "type": "Int"
                                  },
                                  {
                                    "kind": "Literal",
                                    "name": "sortBy",
                                    "value": "CUSTOM",
                                    "type": "PortfolioItemsSortByTypes"
                                  }
                                ],
                                "concreteType": "PortfolioItemsConnection",
                                "plural": false,
                                "selections": [
                                  (v36/*: any*/),
                                  (v40/*: any*/),
                                  {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "pageInfo",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "PageInfo",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "kind": "ScalarField",
                                        "alias": null,
                                        "name": "startCursor",
                                        "args": null,
                                        "storageKey": null
                                      },
                                      (v42/*: any*/)
                                    ]
                                  },
                                  {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "edges",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "PortfolioItemsEdge",
                                    "plural": true,
                                    "selections": [
                                      {
                                        "kind": "LinkedField",
                                        "alias": null,
                                        "name": "node",
                                        "storageKey": null,
                                        "args": null,
                                        "concreteType": "PortfolioItemV2",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "item",
                                            "storageKey": null,
                                            "args": null,
                                            "concreteType": "Item",
                                            "plural": false,
                                            "selections": [
                                              (v84/*: any*/),
                                              (v1/*: any*/)
                                            ]
                                          },
                                          (v1/*: any*/)
                                        ]
                                      }
                                    ]
                                  }
                                ]
                              },
                              (v85/*: any*/)
                            ]
                          }
                        ]
                      }
                    ]
                  },
                  {
                    "kind": "LinkedHandle",
                    "alias": null,
                    "name": "portfolios",
                    "args": (v87/*: any*/),
                    "handle": "connection",
                    "key": "FoldersRefetchWrapper_portfolios",
                    "filters": [
                      "portfolioTypes",
                      "sortBy",
                      "userIds"
                    ]
                  }
                ]
              },
              (v86/*: any*/)
            ]
          },
          {
            "kind": "Condition",
            "passingValue": true,
            "condition": "isSinglePortfolio",
            "selections": [
              (v20/*: any*/),
              (v21/*: any*/),
              (v16/*: any*/),
              (v23/*: any*/),
              (v24/*: any*/),
              (v81/*: any*/),
              {
                "kind": "Condition",
                "passingValue": true,
                "condition": "useProjectEndpoint",
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "project",
                    "storageKey": null,
                    "args": [
                      {
                        "kind": "Variable",
                        "name": "id",
                        "variableName": "projectId",
                        "type": "String!"
                      }
                    ],
                    "concreteType": "Project",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "portfolio",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "PortfolioV2",
                        "plural": false,
                        "selections": (v88/*: any*/)
                      },
                      (v1/*: any*/)
                    ]
                  }
                ]
              },
              (v86/*: any*/),
              {
                "kind": "Condition",
                "passingValue": false,
                "condition": "useProjectEndpoint",
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": "folderPortfolios",
                    "name": "portfolios",
                    "storageKey": null,
                    "args": [
                      (v32/*: any*/),
                      {
                        "kind": "Variable",
                        "name": "portfolioIds",
                        "variableName": "portfolioIds",
                        "type": "[String]"
                      }
                    ],
                    "concreteType": "PortfoliosConnection",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "edges",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "PortfoliosEdge",
                        "plural": true,
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "node",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "PortfolioV2",
                            "plural": false,
                            "selections": (v88/*: any*/)
                          }
                        ]
                      }
                    ]
                  }
                ]
              },
              (v72/*: any*/),
              (v64/*: any*/),
              (v79/*: any*/),
              (v28/*: any*/),
              (v80/*: any*/)
            ]
          },
          {
            "kind": "Condition",
            "passingValue": false,
            "condition": "hasUserId",
            "selections": [
              (v24/*: any*/),
              (v20/*: any*/),
              (v86/*: any*/)
            ]
          },
          {
            "kind": "Condition",
            "passingValue": true,
            "condition": "hasUserId",
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "user",
                "storageKey": null,
                "args": (v13/*: any*/),
                "concreteType": "User",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "isVip",
                    "args": null,
                    "storageKey": null
                  },
                  (v65/*: any*/),
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "canShowSellerName",
                    "args": null,
                    "storageKey": null
                  },
                  (v1/*: any*/)
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "operationKind": "query",
    "name": "favoritesRootQuery",
    "id": "app-buyer-misc/209.0.0-2019-03-26T14:04:46.491Z/favoritesRootQuery",
    "text": null,
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'c9c98884ae50a9ef7a3e2c675c110e64';
module.exports = node;
